import { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import useKeyPress from '../../../../hooks/useKeyPress';

function ConnectedShortcutsWrapper({ onAll, onEscape, stateShortcuts }) {
  const keyAll = useKeyPress('a', false, true, true);
  const keyEscape = useKeyPress('Escape', false, false, false);
  useEffect(() => {
    if (keyAll && stateShortcuts) { onAll() }
    if (keyEscape) { onEscape() }
  }, [keyAll, keyEscape, onAll, onEscape, stateShortcuts])

  return null;
}

ConnectedShortcutsWrapper.propTypes = {
  onAll: PropTypes.func.isRequired,
  onEscape: PropTypes.func.isRequired
}

const ShortcutsWrapper = connect(
  state => ({
    stateShortcuts: state.stateShortcuts
  })
)(ConnectedShortcutsWrapper);


export default ShortcutsWrapper;
